import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "contexts/LanguageContext";

interface ChooseTypePageProps {
  setDocumentType: (type: 'quotation' | 'contract') => void;
  handleNextStep: () => void;
}

const ChooseTypePage: React.FC<ChooseTypePageProps> = ({ setDocumentType, handleNextStep }) => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center h-[650px]">
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-6">
        {t('documents.selectType')}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full max-w-2xl">
        <button
          onClick={() => {
            setDocumentType('quotation');
            handleNextStep();
          }}
          className="flex flex-col items-center p-6 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:border-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-all"
        >
          <div className="p-3 bg-gradient-to-br from-purple-100 to-purple-200 dark:from-purple-900/30 dark:to-purple-800/30 rounded-full mb-4">
            <DocumentTextIcon className="h-10 w-10 text-purple-600 dark:text-purple-400" />
          </div>
          <span className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">{t('documents.quotation')}</span>
          <span className="text-sm text-gray-500 dark:text-gray-400 text-center">
            {t('documents.quotationDescription')}
          </span>
        </button>
        <button
          onClick={() => {
            setDocumentType('contract');
            handleNextStep();
          }}
          className="flex flex-col items-center p-6 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:border-teal-400 hover:bg-teal-50 dark:hover:bg-teal-900/20 transition-all"
        >
          <div className="p-3 bg-gradient-to-br from-teal-100 to-teal-200 dark:from-teal-900/30 dark:to-teal-800/30 rounded-full mb-4">
            <DocumentTextIcon className="h-10 w-10 text-teal-600 dark:text-teal-400" />
          </div>
          <span className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">{t('documents.contract')}</span>
          <span className="text-sm text-gray-500 dark:text-gray-400 text-center">
            {t('documents.contractDescription')}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ChooseTypePage;
